<template>
  <b-button @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? tooltip : ''">⛶</b-button>
</template>

<script>


export default ({
  name: "button-full-screen",

  props: {
    variant: {
      type: String,
      default: 'secondary'
    },
    tooltip: {
      type: String,
      default: 'Местоположение'
    },
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips
    }
  }
})
</script>
